// PRO-563. The "Product recommendation" section of a GPT action. The engine mirrors these defaults in
// product-recommendation.prompt.js — an action saved before this section existed carries no
// `productRecommendation` key at all, and both sides have to read that as the same thing.
export const PRODUCT_RECOMMENDATION_DEFAULTS = Object.freeze({
  enabled: false,
  relevantInformation: '',
  showContinue: false,
  // On, because the assistant has always offered quick replies — the toggle can only ever take them away.
  quickFilters: true,
  layout: ''
})

export const PRODUCT_RECOMMENDATION_FIELDS = Object.freeze({
  QUICK_FILTERS: {
    label: 'Offer quick filters',
    tooltip: 'Experimental. Lets the assistant offer tappable suggestions ("adidas", "up to 500 EUR") ' +
      'next to its replies. On by default; turning it off makes it ask in plain text instead.'
  },
  SHOW_CONTINUE: {
    label: 'Offer a "more products" button',
    tooltip: 'Adds a button under the products that loads the next ones from the knowledge base, ' +
      'leaving out what the customer has already been shown.'
  },
  LAYOUT: {
    label: 'Recommendation display',
    tooltip: 'How product cards are presented. <b>Automatic</b> picks per answer: one product as a hero, ' +
      'a photo-led grid when the customer asks what something looks like, rows otherwise.'
  }
})

// '' = the engine's own per-answer heuristics (product-layout.js), which is what every bot does today.
export const PRODUCT_LAYOUT_OPTIONS = Object.freeze([
  { value: '', text: 'Automatic' },
  { value: 'carousel', text: 'Carousel' },
  { value: 'rows', text: 'Rows' },
  { value: 'grid', text: 'Grid' },
  { value: 'hero', text: 'Hero' }
])

// PRO-740: what the Display preview renders — invented products, no feed needed. PRO-741 replaces this with
// real products from the selected feed.
const SAMPLE_IMAGE = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200">' +
  '<rect width="200" height="200" fill="%23efefef"/></svg>'

export const SAMPLE_PRODUCT_CARDS = Object.freeze([
  { title: 'Trail running shoe', subtitle: 'Brand A', image_url: SAMPLE_IMAGE, details: { product: { price: '2 490 Kč' } } },
  {
    title: 'Road running shoe', subtitle: 'Brand B', image_url: SAMPLE_IMAGE,
    details: { product: { price: '1 990 Kč', price_original: '2 490 Kč', discount_percent: 20 } }
  },
  { title: 'Running socks', subtitle: 'Brand C', image_url: SAMPLE_IMAGE, details: { product: { price: '290 Kč' } } }
])
